import { pipe } from 'fxjs/es';
import { changeColorOfCvImage, getCvImage, objForCvImageFrameTmpl } from './fs.js';
import { makeCvImageFrameHtml, makeMConInfoFrameHtml } from './tmpl.js';
import { makeAutoSwiperActive } from '../util.js';
import { SVGEditorUtilF } from '../../../SVGEditor/Util/F/Function/module/SVGEditorUtilF.js';
import { NewMakerMenuF } from '../../../NewMaker/Menu/F/Function/module/NewMakerMenuF.js';
import { hydrationRune } from '@modules/OMP/Core/Util/F/Function/rune.js';
import { License } from '@services/Marpple/client/widgets/CreatorDesign/ui/atoms/License/License.ts';

$.frame.defn_frame({
  frame_name: 'maker.image_color',
  el_class: 'image_color maker_dialog editor_menu after_bar',
  el_id: 'image_color_app',
  page_name: 'maker.image_color',
  title: T('Color'),
  animation: true,
  height: 158 + 48 + G.mp.frame.v_height,
  header_height: 48 + G.mp.frame.v_height,
  always_remove: true,
  hide_frame_button_type: 'V',
  prev_frame_show: true,
  appended: function (frame_el) {
    if (T.lang === 'kr') {
      const cv_image = getCvImage(G.mp.maker.active());
      const color_name = cv_image._data['press_color_name' + _en] || '색 이름 없음';
      $.add_class($1('[frame_name="maker.image_color"] >.don_wrapper >.header >.title'), 'color_name');
      _go($1('[frame_name="maker.image_color"] .color_name'), $.text(color_name));
    }
    G.mp.maker.zoom.by_active1(G.mp.maker.active(), 158 + 48 + G.mp.frame.v_height);
    SVGEditorUtilF.halfFrameClose(frame_el);
  },
  closing: function () {
    G.mp.maker.ban_frame_hide();
    G.mp.maker.zoom.recover();
  },
  closed: function () {
    G.mp.maker.modified();
  },
  showing: function () {
    G.mp.maker.ban_frame_show();
  },
  showed: $.on_prevent_default,
  hiding: $.off_prevent_default,
});

$.frame.defn_page({
  page_name: 'maker.image_color',
  tabs: [
    {
      tab_name: 'maker.image_color',
      template: pipe(objForCvImageFrameTmpl, makeCvImageFrameHtml),
      appended: _pipe(
        _p.tap(function (tab_el) {}),
        $.on('click', '.image_color_item', async function (e) {
          if (!G.mp.maker.active()) return $.frame.close();
          try {
            const currentTarget = e.currentTarget;
            const image_color = box.sel(currentTarget);
            await changeColorOfCvImage(image_color);
            $.selectable3(currentTarget);
            if (T.lang === 'kr')
              _go(
                $1('#image_color_app .color_name'),
                $.text(image_color['press_color_name' + _en] || T('maker::Unknown')),
              );
          } catch (e) {
            if (e === 'not_available_color') return $.alert(T('선택된 색상으로 패턴을 만들수 없습니다.'));
            throw e;
          }
        }),
      ),
      showed: function (el_tab) {
        makeAutoSwiperActive(el_tab);
      },
    },
  ],
});

export function openMakerImageColorFrame() {
  $.frame.open({
    frame_name: 'maker.image_color',
  });
}

/**
 * ## MCON 이미지 정보 프레임
 */
$.frame.defn_frame({
  frame_name: 'maker.mcon_info',
  el_class: 'mcon_info after_bar',
  animation: true,
  prev_frame_show: true,
  always_remove: true,
  page_name: 'mcon_info_page',
  height: 234,
  header_height: 48 + G.mp.frame.v_height,
  hide_frame_button_type: 'V',
  closing: __(function () {
    $.remove_class($1('#maker_frame'), 'mcon_info_mode');
    G.mp.maker.ban_frame_hide();
    // G.mp.maker.zoom.recover();
    G.mp.maker.zoom.recover();
  }),
  showing: function () {
    // G.mp.maker.unselect_all();
    G.mp.maker.ban_frame_show();
    G.mp.maker.zoom.by_active1(G.mp.maker.active(), 120 + 16 + 48 + G.mp.frame.v_height);
  },
  makeData: function () {
    const mcon_info = G.mp.maker.active()._data.mcon_info;
    return {
      mcon_info,
      mcon_info_image: mcon_info.image,
      mcon_info_name: mcon_info.name,
      mcon_info_description: mcon_info.description,
      mcon_info_creator: mcon_info.creator,
      mcon_info_creator_url: mcon_info.creator_url,
      mcon_info_creator_image: mcon_info.creator_image,
    };
  },
  appending: function () {
    NewMakerMenuF.hide();
    $.add_class($1('#maker_frame'), 'mcon_info_mode');
  },
  appended: $.frame_close_bg,
  showed: () => {
    $.on_prevent_default();
    hydrationRune(License);
  },
  hiding: $.off_prevent_default,
});

$.frame.defn_page({
  page_name: 'mcon_info_page',
  tabs: [
    {
      tab_name: 'mcon_info_tab',
      template: pipe(makeMConInfoFrameHtml),
    },
  ],
});

export function openMconInfoImageFrame() {
  $.frame.open({
    title: TT('NewMaker::Mcon::mcon_etc_1'),
    frame_name: 'maker.mcon_info',
  });
}
